import React from "react";
import "./Who_Should_Use_This_img_holder.css";

function Who_Should_Use_This_img_holder({headingText , subText , image}) {
  return (
    <>
      <section className="Who_Should_Use_This_img_holder">
        <div className="img_holder">
          <img
            className="Who_Should_Use_img"
            src={
              process.env.PUBLIC_URL + image
            }
            alt="Who_Should_Use_img"
          />
        </div>

        <div className="text_holder">
          <h6>{headingText} </h6>
          <p>{subText}</p>
        </div>

        <div className="overlay_holder"></div>
      </section>
    </>
  );
}

export default Who_Should_Use_This_img_holder;
